"use client";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import classNames from 'classnames';
import * as React from 'react';
import { useUncontrolled } from 'uncontrollable';
import useEventCallback from '@restart/hooks/useEventCallback';
import { useBootstrapPrefix } from './ThemeProvider';
import AlertHeading from './AlertHeading';
import AlertLink from './AlertLink';
import Fade from './Fade';
import CloseButton from './CloseButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Alert = /*#__PURE__*/React.forwardRef(function (uncontrolledProps, ref) {
  var _useUncontrolled = useUncontrolled(uncontrolledProps, {
    show: 'onClose'
  }),
      bsPrefix = _useUncontrolled.bsPrefix,
      _useUncontrolled$show = _useUncontrolled.show,
      show = _useUncontrolled$show === void 0 ? true : _useUncontrolled$show,
      _useUncontrolled$clos = _useUncontrolled.closeLabel,
      closeLabel = _useUncontrolled$clos === void 0 ? 'Close alert' : _useUncontrolled$clos,
      closeVariant = _useUncontrolled.closeVariant,
      className = _useUncontrolled.className,
      children = _useUncontrolled.children,
      _useUncontrolled$vari = _useUncontrolled.variant,
      variant = _useUncontrolled$vari === void 0 ? 'primary' : _useUncontrolled$vari,
      onClose = _useUncontrolled.onClose,
      dismissible = _useUncontrolled.dismissible,
      _useUncontrolled$tran = _useUncontrolled.transition,
      transition = _useUncontrolled$tran === void 0 ? Fade : _useUncontrolled$tran,
      props = _objectWithoutProperties(_useUncontrolled, ["bsPrefix", "show", "closeLabel", "closeVariant", "className", "children", "variant", "onClose", "dismissible", "transition"]);

  var prefix = useBootstrapPrefix(bsPrefix, 'alert');
  var handleClose = useEventCallback(function (e) {
    if (onClose) {
      onClose(false, e);
    }
  });
  var Transition = transition === true ? Fade : transition;

  var alert = /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread({
    role: "alert"
  }, !Transition ? props : undefined), {}, {
    ref: ref,
    className: classNames(className, prefix, variant && "".concat(prefix, "-").concat(variant), dismissible && "".concat(prefix, "-dismissible")),
    children: [dismissible && /*#__PURE__*/_jsx(CloseButton, {
      onClick: handleClose,
      "aria-label": closeLabel,
      variant: closeVariant
    }), children]
  }));

  if (!Transition) return show ? alert : null;
  return /*#__PURE__*/_jsx(Transition, _objectSpread(_objectSpread({
    unmountOnExit: true
  }, props), {}, {
    ref: undefined,
    in: show,
    children: alert
  }));
});
Alert.displayName = 'Alert';
export default Object.assign(Alert, {
  Link: AlertLink,
  Heading: AlertHeading
});